import {
  useHandlers,
  withPageProviders,
} from '@sparklayer-io/spark-dash-pages/context/page-context';
import { Heading, LearnMoreLink, Page, Text } from '@ui/themed';
import { t } from 'i18next';
import { CustomerLookupSearch } from '../../customers-sync/components/customer-lookup-search';
import { CUSTOMERS_SYNC_PATH } from '../../customers-sync/constants';
import { useSalesAgentsUnavailable } from '../../customers-sync/hooks/use-sales-agents-unavailable';
import { SalesAgentsUpsell } from '../components/sales-agents-upsell';
import { I18N_PAGE, SALES_AGENT_ORDERING_URL } from '../constants';

export const SalesAgentsPage = withPageProviders(() => {
  const { navigationHandler } = useHandlers();
  const salesAgentsUnavailable = useSalesAgentsUnavailable();

  return (
    <Page
      title={t(`${I18N_PAGE}.title`)}
      description={t(`${I18N_PAGE}.description`)}
      learnMoreUrl={SALES_AGENT_ORDERING_URL}
    >
      {/* A plan with no sales agents has nobody to look up, so the upsell stands alone. */}
      {!salesAgentsUnavailable && (
        <>
          <div className="flex flex-col gap-1">
            <Heading style="md" level="h2">
              {t(`${I18N_PAGE}.lookup_title`)}
            </Heading>
            <Text variant="secondary">
              {t(`${I18N_PAGE}.lookup_description`)}{' '}
              <LearnMoreLink link={SALES_AGENT_ORDERING_URL} />
            </Text>
          </div>

          <CustomerLookupSearch
            onSelect={(_customer, identifier) =>
              navigationHandler.navigate(
                `${CUSTOMERS_SYNC_PATH}/${encodeURIComponent(identifier)}`,
                { newTab: true },
              )
            }
          />
        </>
      )}

      <SalesAgentsUpsell />
    </Page>
  );
});
